var SCM = SCM || {};

(function (ns, $) {
       
    ns.initInstitutionalSettings = function () {
        //update institutional Account Info
        var initialErrorSummaryValue = $('.error-summary').html();
        $('#institutionalAccountInfo').on('click', '#saveInstitutionalSettingsBtn', function () {
            const $button = $('#saveInstitutionalSettingsBtn');
            var $formContainer = $(this).closest('#institutionalAccountInfo');
            var $errorSummary = $formContainer.find('.error-summary');
            $errorSummary.html(initialErrorSummaryValue);
            var $successMsg = $formContainer.find('.instUpdate-success');

            $button.addClass('disabled');

            // hide previous msgs
            $successMsg.hide();
            $errorSummary.hide();
            $formContainer.find('.instUpdate-error').html('').removeClass('is-active');

            var $institutionId = $formContainer.find('#hdnSelectedInstitutionId');
            var $instName = $formContainer.find('#instSet-InstitutionName');
            var $ipAddresses = $formContainer.find('#instSet-IpAddresses');
            var $orgId = $formContainer.find('#instSet-OrgId');
            var $entityId = $formContainer.find('#instSet-EntityId');
            var $openUrl = $formContainer.find('#instSet-OpenUrl');
            var $openUrlButton = $formContainer.find('#instSet-OpenUrlButton');
            var $instUrl = $formContainer.find('#instSet-InstUrl');
            var $instLogoUrl = $formContainer.find('#instSet-InstLogo');
            var token = $('#myaccount-tabs-content').find('#MyAccountToken').val();

            $.post('/OUPMyAccount/UpdateInstitutionalAccountInfo',
                {
                    institutionId: $institutionId.val(),
                    institutionName: $instName.val(),
                    ipAddresses: $ipAddresses.val(),
                    orgId: $orgId.val(),
                    entityId: $entityId.val(),
                    openUrl: $openUrl.val(),
                    openUrlButton: $openUrlButton.val(),
                    instUrl: $instUrl.val(),
                    instLogoUrl: $instLogoUrl.val(),
                    token: token,
                    ipAddresessChanged: $ipAddresses.val() !== $ipAddresses.data('default')
                },
                function (data) {
                    $button.removeClass('disabled');
                    if (data !== undefined && data !== null) {
                        if (data.ReturnId) {
                            $('#myaccount-tabs-content').find('#MyAccountToken').val(data.ReturnId);
                        }

                        if (!$.isEmptyObject(data.Errors)) {
                            showError(data.Errors, $formContainer, $errorSummary, data);
                        }
                        else {
                            showSuccess($successMsg, $openUrlButton.val(), $instLogoUrl.val());

                            $institutionId.data('default', $institutionId.val());
                            $instName.data('default', $instName.val());
                            $ipAddresses.data('default', $ipAddresses.val());
                            $orgId.data('default', $orgId.val());
                            $entityId.data('default', $entityId.val());
                            $openUrl.data('default', $openUrl.val());
                            $openUrlButton.data('default', $openUrlButton.val());
                            $instUrl.data('default', $instUrl.val());
                            $instLogoUrl.data('default', $instLogoUrl.val());

                            $('#InstitutionList option:selected').text($instName.val());
                        }
                    }
                });
        });

        // copy corresponding help text to modal
        $(document).on('click', '#institutionalAccountInfo .js-question-icon', function (e) {
            e.preventDefault();

            var helpText = $(this).next('[data-type="help-text"]').html();

            $('#institutionalSettingsModalBody').html(helpText);
            $('#institutionalSettingsModal').foundation('reveal', 'open');
        });

        var lastSel = $('.js-institution-list option:selected');
        $('.js-institution-list').on('change', function () {
            if (hasUnsavedChanges()) {
                alert('You have unsaved changes.');
                lastSel.attr('selected', true);
            }
            else {
                window.location = '/my-account/institutional-settings/' + $(this).val();
            }
        });
    };

    function showSuccess($successMsg, openUrlButton, instLogoUrl) {
        $successMsg.show();

        if ($.trim(openUrlButton).length) {
            $('#instSet-OpenUrlButtonImg').attr('src', openUrlButton).show();
        }
        else {
            $('#instSet-OpenUrlButtonImg').hide();
        }

        if ($.trim(instLogoUrl).length) {
            $('#instSet-InstLogoImg').attr('src', instLogoUrl).show();
        }
        else {
            $('#instSet-InstLogoImg').hide();
        }
    }

    function showError(errors, $formContainer, $errorSummary, data) {
        for (var key in errors) {
            var inputId = null;

            switch (key) {
                case 'general':
                    inputId = 'general';
                    break;
                case 'institutionName':
                    inputId = 'instSet-InstitutionName';
                    break;
                case 'ipAddressList':
                    inputId = 'instSet-IpAddresses';
                    break;
                case 'orgId':
                    inputId = 'instSet-OrgId';
                    break;
                case 'entityId':
                    inputId = 'instSet-EntityId';
                    break;
                case 'openUrl':
                    inputId = 'instSet-OpenUrl';
                    break;
                case 'openUrlButton':
                    inputId = 'instSet-OpenUrlButton';
                    break;
                case 'instUrl':
                    inputId = 'instSet-InstUrl';
                    break;
                case 'instLogoUrl':
                    inputId = 'instSet-InstLogo';
                    break;
            }

            if (inputId !== null) {
                if (inputId === 'general') {
                    $formContainer.find('.instUpdate-error.general-error').html(data.Errors[key]).addClass('is-active');
                }
                else {
                    $formContainer.find('#' + inputId).next('.instUpdate-error').html(data.Errors[key]).addClass('is-active');
                    $errorSummary.append('<p> * ' + $('label[for="' + inputId + '"]').text().replace('*', '') + '</p>');
                    $errorSummary.show();
                }
            }
        }

        $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
    }

    function hasUnsavedChanges() {
        var $instName = $('#instSet-InstitutionName');
        var $ipAddresses = $('#instSet-IpAddresses');
        var $orgId = $('#instSet-OrgId');
        var $entityId = $('#instSet-EntityId');
        var $openUrl = $('#instSet-OpenUrl');
        var $openUrlButton = $('#instSet-OpenUrlButton');
        var $instUrl = $('#instSet-InstUrl');
        var $instLogoUrl = $('#instSet-InstLogo');

        if ($instName.val() !== $instName.data('default')) {
            return true;
        }
        if ($ipAddresses.val() !== $ipAddresses.data('default')) {
            return true;
        }
        if ($orgId.val() !== $orgId.data('default')) {
            return true;
        }
        if ($entityId.val() !== $entityId.data('default')) {
            return true;
        }
        if ($openUrl.val() !== $openUrl.data('default')) {
            return true;
        }
        if ($openUrlButton.val() !== $openUrlButton.data('default')) {
            return true;
        }
        if ($instUrl.val() !== $instUrl.data('default')) {
            return true;
        }
        if ($instLogoUrl.val() !== $instLogoUrl.data('default')) {
            return true;
        }

        return false;
    }

})(SCM.MyAccount = SCM.MyAccount || {}, jQuery);